export default __webpack_public_path__ + "static/media/806.7cd19f62.png";